import React from 'react';
import './styles/Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>&copy; 2025 Area 51 Deals. All rights reserved.</p>
  </footer>
);

export default Footer;
